import { render, staticRenderFns } from "./editOrderMode.vue?vue&type=template&id=2c12df71&scoped=true&"
import script from "./editOrderMode.vue?vue&type=script&lang=js&"
export * from "./editOrderMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c12df71",
  null
  
)

export default component.exports